import React, { useEffect, useState, ReactNode } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import {
  matchUserRoleWithCurrentPath,
  validateTokenAndLogoutIfExpired,
} from "../../common/getValidToken";
import { useRole } from "../../context/RoleContext";

interface ProtectedRouteProps {
  element?: ReactNode;
  children?: ReactNode;
}

const ProtectedRoute = ({
  element,
  children,
}: ProtectedRouteProps): React.ReactElement | null => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const { role, setRole } = useRole();
  const orgId = localStorage.getItem("orgId");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkTokenAndRole = async () => {
      const token = await validateTokenAndLogoutIfExpired(navigate);
      const currentPathRole = location.pathname.split(`/${orgId}`)[1];

      if (token && matchUserRoleWithCurrentPath(currentPathRole, navigate)) {
        setIsAuthenticated(true);
      } else {
        setRole("");
        setIsAuthenticated(false);
      }
    };

    checkTokenAndRole();
  }, [role, location.pathname, navigate, setRole]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  if (isAuthenticated) {
    return <>{children || element || null}</>;
  }

  return <Navigate to={`/`} replace />;
};

export default ProtectedRoute;
